import { config } from "../../config"
import { zip } from "../../helpers/utils"

export const suggestions = {
  readAll: ({ from = null, limit = null, match = null, token }) => {
    const base = config.apiUrl + `/suggestions`,
      opt = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    const params = zip([from, limit, match], ["f", "l", "q"])

    let query = params
      .filter((param) => param[0] !== null && param[0] !== "")
      .map((param) => `&${param[1]}=${param[0]}`)
      .join("")

    if (query.length) query = "?" + query.substr(1)

    return { url: base + query, opt }
  },

  create: ({ sugg }) => {
    const url = config.apiUrl + `/suggestions`,
      opt = {
        method: "POST",
        headers: {
          //   'Authorization': `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sugg),
      }

    return { url, opt }
  },

  delete: ({ token, sug_id }) => {
    const url = config.apiUrl + `/suggestions/${sug_id}`,
      opt = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    return { url, opt }
  },
}
